<template>
	<textarea v-if="!debug" class="string-view" @input="handleInput($event)" :value="modelValue" @keydown="logKey" @touchstart="startLongPress" @touchend="clearLongPress" @touchmove="clearLongPress" />
	<textarea v-else class="string-view debug" :value="formattedKeyLog" @touchstart="startLongPress" @touchend="clearLongPress" @touchmove="clearLongPress" />
</template>

<script>
export default {
	name: 'text-view',
	props: ['modelValue'],
	data() {
		return {
			debug: false,
			keyLog: [],
			longPressTimer: null,
			longPressDuration: 1000,
		};
	},
	computed: {
		formattedKeyLog() {
			return this.keyLog.map((entry) => `[${new Date(entry.timestamp).toLocaleTimeString()}] Key: "${entry.key}" (${entry.code})`).join('\n');
		},
	},
	methods: {
		handleInput(event) {
			const val = event.target.value;

			// Add a character to force reactivity
			this.$emit('update:modelValue', val + 'a', event);
			this.$emit('update:modelValue', val, event);
		},
		logKey(event) {
			this.keyLog.push({
				key: event.key,
				code: event.code,
				timestamp: Date.now(),
			});

			// Keep log manageable (e.g., last 100 keypresses)
			if (this.keyLog.length > 100) {
				this.keyLog.shift();
			}
		},
		startLongPress(event) {
			console.log('Long press started!');

			this.longPressTimer = setTimeout(() => {
				console.log('Long press detected!');
				this.debug = !this.debug;
			}, this.longPressDuration);
		},
		clearLongPress() {
			clearTimeout(this.longPressTimer);
			this.longPressTimer = null;
		},
	},
	emits: ['update:modelValue']
};
</script>

<style lang="scss" scoped>
.string-view {
	height: 200px;
	padding: 10px 10px 10px 10px;

	&.debug {
		background: blue;
		color: white;
	}
}
</style>
